import React, { useState, useRef, useContext, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Message } from "primereact/message";
import { applicationsService } from "../../services/ApplicationsService";
import { authenticationService } from "../../services/AuthenticationService";
import "./ViewApplication.css";
import App, { AppDB } from "../../App";
import GenericViewApplication from "./GenericViewApplication";
import {
	APPLICATION_STATUS_REFERRED,
	APPLICATION_TYPE_OBJECTION,
	APPLICATION_TYPE_REMOVAL,
	APPLICATION_TYPE_TRANSFER,
	APPLICATION_TYPE_CORRECTION,
	CHANNEL_CATEGORY_UNASSISTED,
	permissionLookUp
} from "../../constants";
import PrintOutAction from "../reports/PrintOutAction";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Image } from "primereact/image";
import { confirmPopup } from "primereact/confirmpopup";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { applicationLocks } from "../../services/ApplicationLocks";
import { MultiSelect } from "primereact/multiselect";
import { changeLang } from "../../componets/Language/ChangeLang";
import { usersService } from "../../services/UsersService";
import { use } from "react";
import { get } from "lodash";
import { useIsAuthenticated } from "@azure/msal-react";
import CorrectionView from "./corrections/CorrectionView";
import { votersService } from "../../services/VotersService";

function fileToBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const base64String = reader.result;
			// Split the base64 string at the comma
			const base64Parts = base64String.split(",");
			// Return the second part (index 1)
			resolve(base64Parts[1]);
		};
		reader.onerror = (error) => reject(error);
		reader.readAsDataURL(file);
	});
}

function fileToBase64_v2(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const base64String = reader.result;
			// Split the base64 string at the comma
			console.log(base64String);
			// Return the second part (index 1)
			resolve(base64String);
		};
		reader.onerror = (error) => reject(error);
		reader.readAsDataURL(file);
	});
}

export default function ViewApplication({
	ApplicationInfo,
	applicationID,
	referenceNumber,
	applicationTypeID,
	idNumber,
	visible,
	onHide,
	onSubmit,
	canTransact = false
}) {
	const [application, setApplication] = useState(null);
	const [popUpInfo, setPopUpInfo] = useState({});
	const [voter, setVoter] = useState(null);
	const fileRef = useRef(null);
	const [loading, setLoading] = useState(false);
	const [showTransaction, setShowTransaction] = useState(false);
	const [objectionForm, setObjectionForm] = useState({
		Recommend: false,
		Withdraw: false,
		show: false
	});
	const [showReport, setShowReport] = useState(false);
	const [referBackIsTest] = useState(true);
	const [openedByUser, setOpenedByUser] = useState(null);
	const [canEdit, setCanEdit] = useState(true);
	const [correctionLoading, setcorrectionLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState("");
	var [filesUpload, setFilesUpload] = useState([]);
	var { refreshingApplication, seRefreshingApplication, userInfo } = useContext(AppDB);
	var { permission, setPermission, toast, setShowEditRegistration, lookUp } = useContext(AppDB);
	const [showCorrectionDetails, setshowCorrectionDetails] = useState(false);
	const [correctionDetails, setcorrectionDetails] = useState(null);
	const [binaryData, setBinaryData] = useState(null);
	const [binaryLoading, setBinaryLoading] = useState(false);
	const deleteConform = (event, id) => {
		filesUpload = filesUpload.filter((_, i) => i !== id);
		setFilesUpload([...filesUpload]);
		// confirmPopup({
		// 	target: event.currentTarget,
		// 	message: 'Are you sure you want to proceed?',
		// 	icon: 'pi pi-exclamation-triangle',
		// 	// defaultFocus: 'accept',
		// 	accept: () => {
		// 		filesUpload = filesUpload.filter((_, i) => i !== id)
		// 		setFilesUpload({ ...filesUpload })
		// 	},
		// 	reject: () => { }
		// });
	};

	function canHideReferral() {
		return (ApplicationInfo?.applicationTypeID == 1 || ApplicationInfo?.applicationTypeID == 3) && ApplicationInfo?.channelCategoryID !== 11;
	}
	// useEffect(() => {
	// 	if ((ApplicationInfo.applicationTypeID == 1 || ApplicationInfo.applicationTypeID == 3) && ApplicationInfo?.channelCategoryID !== 11) return;
	// 	setPermission({
	// 		...permission,
	// 		Referral: false
	// 	});

	// }, [permission, setPermission]);

	async function transact(transaction, note = null, binaryTypeID = null, file = null) {
		setLoading(true);
		setErrorMessage("");

		var binaryData = JSON.parse(JSON.stringify(filesUpload));

		binaryData = binaryData.map((e) => {
			delete e.preivew;
			try {
				e.binaryData = e.binaryData.split(",")[1];
			} catch (error) { }
			return e;
		});
		var data = {
			applicationTypeID,
			applicationIDs: [applicationID],
			reason: note,
			note: note,
			applicationChecks: [],
			binaryData: binaryData,
			findingDate: popUpInfo.findingDate,
			removalFindingID: popUpInfo.removalFindingID
		};

		// const data = {
		// 	applicationIDs: [applicationID],
		// 	userID: authenticationService.getCurrentUser().userID,
		// 	reason: reason,
		// 	note: note,
		// 	file: file
		// };

		try {
			var response;

			if (transaction === "Approve") {
				response = await applicationsService.accept(data);
			} else {
				response = await applicationsService.reject(data);
			}

			setLoading(false);

			if (response.data[0].success) {
				//setShowTransaction(false);
				onSubmit();

				seRefreshingApplication(!refreshingApplication);
				return toast.show({
					severity: "success",
					summary: "Success Message",
					detail: transaction === "Approve" ? "Application approved successfully" : "Application rejected successfully",
					life: 1500
				});
			} else {
				setErrorMessage(response.data[0].message);
				toast.show({
					severity: "error",
					summary: "Error",
					detail: response.data[0].message,
					life: 2500
				});
			}
		} catch (error) {
			setLoading(false);
			toast.show({
				severity: "error",
				summary: "Error",
				detail: "Remote server error occured. Please try again or consult your system adminstrator.",
				life: 2500
			});
			setErrorMessage("Remote server error occured. Please try again or consult your system adminstrator.");
		}
	}

	function submitApplication() {
		var files = fileRef.current.getFiles();

		if (!popUpInfo.findingDate) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: "Finding date is required",
				life: 2500
			});
		}
		if (!popUpInfo.removalFindingID) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: "Finding reason is required",
				life: 2500
			});
		}
		if (!popUpInfo.note) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: "note is required",
				life: 2500
			});
		}
		// if (!popUpInfo.removal_reason) {
		// 	return toast.show({
		// 		severity: "error",
		// 		summary: "Error",
		// 		detail: 'document type is required',
		// 		life: 2500
		// 	});
		// }
		if (filesUpload.length === 0) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: "attachment(s) are required",
				life: 2500
			});
		}
		transact(popUpInfo?.transact, popUpInfo.note, 13, files[0]);
	}

	function objectionApplication() {
		if (objectionForm.Recommend === true) {
			if (!popUpInfo.actionTaken) {
				return toast.show({
					severity: "error",
					summary: "",
					detail: "Action Taken is required",
					life: 2500
				});
			}
		}

		if (!popUpInfo.note) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: `${objectionForm.Recommend ? "Recommendation " : "Notes"} is required`,
				life: 2500
			});
		}
		if (filesUpload.length === 0) {
			return toast.show({
				severity: "error",
				summary: "",
				detail: "attachment(s) are required",
				life: 2500
			});
		}

		var binaryData = JSON.parse(JSON.stringify(filesUpload));

		binaryData = binaryData.map((e) => {
			delete e.preivew;
			if (e.binaryData.split(",")?.length >= 2) {
				e.binaryData = e.binaryData.split(",")[1];
			}

			return e;
		});
		var data = {
			applicationTypeID,
			applicationID: applicationID,
			recommendations: popUpInfo.note,
			actionTaken: popUpInfo.actionTaken,
			actionsTaken: popUpInfo.actionTaken,
			binaryData: binaryData,
			removalFindingID: popUpInfo.removalFindingID
		};

		setLoading(true);
		if (objectionForm.Recommend) {
			applicationsService.recommend(data).then((res) => {
				setLoading(false);
				if (res.success) {
					toast.show({
						severity: "success",
						detail: "Application submitted successfully",
						life: 1500
					});
					onSubmit();
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
		} else {
			applicationsService.withdraw(data).then((res) => {
				setLoading(false);
				if (res.success) {
					toast.show({
						severity: "success",
						detail: "Application submitted successfully",
						life: 1500
					});
					onSubmit();
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
		}
	}

	// console.log(ApplicationInfo);
	function unlockRecord() {
		if (application?.applicationStatusID == APPLICATION_STATUS_REFERRED) {
			setLoading(true);
			applicationLocks.closeApplication(applicationID).then((res) => {
				setLoading(false);
				if (res.success) {
					setApplication(null);
					onHide();
					toast.show({
						severity: "success",
						summary: "Application Unlocked",
						life: 1500
					});
				} else {
					toast.show({
						severity: "error",
						summary: res.message,
						life: 1500
					});
				}
			});
		}
		setApplication(null);
		onHide();
	}

	const [referBack, setReferBack] = useState({
		notes: "",
		show: false,
		notes_length: [undefined, null, "", 0].includes(changeLang.get("referBackMessageLength")) ? 40 : changeLang.get("referBackMessageLength"),
		reasons: []
	});

	function referBackHandler() {
		if (referBack.reasons.length === 0) {
			return toast.show({
				severity: "error",
				detail: "Select atleast one reason.",
				life: 1500
			});
		}

		var obj = {
			applicationID: applicationID,
			applicationTypeID: applicationTypeID,
			referredToID: null,
			referralReasons: [...JSON.parse(JSON.stringify(referBack.reasons))].map((e) => {
				e.referralReasonID = e.id;
				e.notes = e.notes;
				return e;
			})
		};
		setLoading(true);
		applicationsService.refer(obj).then((res) => {
			setLoading(false);
			if (res.success) {
				toast.show({
					severity: "success",
					detail: "Application submitted successfully",
					life: 1500
				});
				setApplication(null);
				onHide();
				onSubmit();
			} else {
				toast.show({
					severity: "error",
					detail: res.message,
					life: 1500
				});
			}
		});
	}

	useEffect(() => {
		async function getOpenedByUser() {
			var applicationRes = await applicationsService.getByID(applicationID);
			setApplication(applicationRes.data);
			if (applicationRes.success === false) {
				if (applicationRes.data?.recordOwnerID != null && applicationRes.data?.recordOwnerID != undefined) {
					var currentUser = await usersService.getByID(applicationRes.data?.recordOwnerID);
					if (currentUser != null) {
						setCanEdit(false);
					}
					setOpenedByUser(currentUser?.userName);
				}
				return;
			}
		}
		getOpenedByUser();
	}, [openedByUser]);

	const viewCorrection = async () => {
		setcorrectionLoading(true);		
		try {
			const correctionRes = await applicationsService.getByID(ApplicationInfo?.parentApplicationID);
			if (correctionRes?.success) {
				setcorrectionDetails(correctionRes.data);
			}

			const parentID = ApplicationInfo?.parentApplicationID;
			if (parentID) {
				const binRes = await applicationsService.getBinaryDataByID(parentID);
				setBinaryData(binRes ?? []);
			}

			setshowCorrectionDetails(true);
		} catch (err) {
			console.error("Error loading correction details:", err);
		} finally {
			setcorrectionLoading(false);
		}
	};

	return (
		<>
			<Dialog
				modal={true}
				style={{ width: "90%", height: "90%" }}
				draggable={false}
				header={
					<>
						<span>
							{application?.applicationType} Application - {referenceNumber}
						</span>
						{openedByUser && <div style={{ fontSize: 12, color: "red" }}>Opened By: {openedByUser}</div>}
					</>
				}
				footer={
					<>
						{((permission?.actions?.includes(permissionLookUp.Update) &&
							permission?.Update === true &&
							canEdit &&
							application?.correction?.createdBy !== userInfo?.userID) ||
							(permission?.actions?.includes(permissionLookUp.Update) && permission?.Update === true && canEdit)) && (
								<>
									<Button className="p-button-primary" type="button" label="Edit" onClick={() => setShowEditRegistration(true)} />
								</>
							)}

						{/* Referral */}
						{/* CHANNEL_CATEGORY_UNASSISTED */}
						{canHideReferral() && (
							<>
								{permission?.actions?.includes(permissionLookUp.Referral) && permission?.Referral === true && (
									<Button
										className="p-button-primary"
										type="button"
										label="Refer Back"
										onClick={(e) => {
											setReferBack({ ...referBack, show: true });
											// setShowEditRegistration(true);
										}}
									/>
								)}
							</>
						)}

						<></>

						{permission?.actions?.includes(permissionLookUp.Recommend) && permission?.Recommend === true && (
							<>
								<Button
									className="p-button-primary"
									icon="pi pi-check"
									type="button"
									label={permission?.RecommendButton || "Recommend"}
									onClick={() => {
										setObjectionForm({ Recommend: true, Withdraw: false, show: true });
									}}
								/>
							</>
						)}

						{permission?.actions?.includes(permissionLookUp.Withdraw) && permission?.Withdraw === true && (
							<>
								<Button
									className="p-button-info"
									icon="pi pi-times"
									type="button"
									label="Withdraw"
									onClick={() => {
										setObjectionForm({ Recommend: false, Withdraw: true, show: true });
									}}
								/>
							</>
						)}
						{permission?.actions?.includes(permissionLookUp.Approve) && permission?.Approve === true && (
							<>
								{ApplicationInfo.applicationType === "Removal" && (
									<>
										{ApplicationInfo.mohaStatus === true && (
											<>
												<Button
													className="p-button-primary"
													icon="pi pi-check"
													type="button"
													label="Approve"
													onClick={() => {
														if (applicationTypeID === APPLICATION_TYPE_REMOVAL) {
															if (ApplicationInfo.mohaStatus) {
																transact("Approve");
															} else {
																setShowTransaction(true);
																setPopUpInfo({ ...popUpInfo, transact: "Approve" });
															}
														} else {
															transact("Approve");
														}
													}}
												/>
											</>
										)}
									</>
								)}

								{ApplicationInfo.applicationType !== "Removal" && (
									<>
										<Button
											className="p-button-primary"
											icon="pi pi-check"
											type="button"
											label="Approve "
											onClick={() => {
												if (applicationTypeID === APPLICATION_TYPE_REMOVAL) {
													if (ApplicationInfo.mohaStatus) {
														transact("Approve");
													} else {
														setShowTransaction(true);
														setPopUpInfo({ ...popUpInfo, transact: "Approve" });
													}
												} else {
													transact("Approve");
												}
											}}
										/>
									</>
								)}
							</>
						)}

						{permission?.actions?.includes(permissionLookUp.Reject) && permission?.Reject === true && (
							<>
								{ApplicationInfo.applicationType === "Removal" && (
									<>
										{ApplicationInfo.mohaStatus === false && (
											<>
												<Button
													className="p-button-primary"
													icon="pi pi-times"
													type="button"
													label="Reject"
													disabled={loading || ApplicationInfo.mohaStatus}
													// onClick={() => transact("Reject")}
													onClick={() => {
														if (applicationTypeID === APPLICATION_TYPE_REMOVAL) {
															setShowTransaction(true);
															setPopUpInfo({ ...popUpInfo, transact: "Reject" });
														} else {
															transact("Reject");
														}
													}}
												/>
											</>
										)}
									</>
								)}

								{applicationTypeID === APPLICATION_TYPE_OBJECTION ? (
									<>
										<Button
											className="p-button-primary"
											icon="pi pi-times"
											type="button"
											label="Reject"
											disabled={loading}
											// onClick={() => transact("Reject")}
											onClick={() => {
												transact("Reject");
											}}
										/>
									</>
								) : (
									<>
										{applicationTypeID === APPLICATION_TYPE_TRANSFER ? (
											<Button
												className="p-button-primary"
												icon="pi pi-times"
												type="button"
												label="Reject"
												disabled={loading}
												onClick={() => {
													transact("Reject");
												}}
											/>
										) : (
											<>
												{ApplicationInfo.applicationType !== "Removal" && (
													<>
														<Button
															className="p-button-primary"
															icon="pi pi-times"
															type="button"
															label="Reject"
															disabled={loading || !ApplicationInfo.hasBrokenRules}
															// onClick={() => transact("Reject")}
															onClick={() => {
																if (applicationTypeID === APPLICATION_TYPE_REMOVAL) {
																	setShowTransaction(true);
																	setPopUpInfo({ ...popUpInfo, transact: "Reject" });
																} else {
																	transact("Reject");
																}
															}}
														/>
													</>
												)}
											</>
										)}
									</>
								)}
							</>
						)}

						{ApplicationInfo?.parentApplicationID && (ApplicationInfo?.transfer !== null || ApplicationInfo?.amendment !== null) && (
							<>
								<Button
									className="p-button-primary"
									icon="pi pi-eye"
									type="button"
									label="View Correction Details"
									disabled={correctionLoading}
									loading={correctionLoading}
									onClick={viewCorrection}
								/>
							</>
						)}
						<Button
							className="p-button-primary"
							type="button"
							label="Print"
							onClick={(e) => {
								setShowReport(true);
							}}
						/>

						<Button
							className="p-button-danger"
							icon="pi pi-times-circle"
							type="button"
							label="Close"
							onClick={() => {
								unlockRecord();
							}}
						/>
					</>
				}
				visible={visible}
				onHide={(e) => {
					unlockRecord();
				}}
				onShow={() => { }}
			>
				<Dialog
					// modal={true}
					style={{ width: "100%", maxWidth: 500, height: "100vh" }}
					draggable={false}
					visible={referBack.show}
					onHide={() => {
						referBack.reasons = [];
						referBack.notes = "";
						setReferBack({ ...referBack, show: false });
					}}
					header={
						<>
							<span>
								{application?.applicationType}Application - {referenceNumber}
							</span>
						</>
					}
					footer={
						<>
							<Button
								className="p-button-primary"
								type="button"
								label="Refer Back"
								loading={loading}
								onClick={() => {
									if (referBack.reasons.length === 0) {
										toast.show({
											severity: "error",
											summary: "Error",
											detail: "Please select at least one reason.",
											life: 2500
										});
										return;
									}
									for (const item of referBack.reasons) {
										if (item.isRequired) {
											toast.show({
												severity: "error",
												summary: "Error",
												detail: item.name + " is required.",
												life: 2500
											});
											return; // Stop here
										}
									}
									referBackHandler();
								}}
							/>
							<Button
								className="p-button-danger"
								icon="pi pi-times-circle"
								type="button"
								label="Cancel"
								onClick={() => {
									referBack.reasons = [];
									referBack.notes = "";
									setReferBack({ ...referBack, show: false });
								}}
							/>
						</>
					}
				>
					<label>Reason</label>
					<MultiSelect
						value={referBack.reasons}
						onChange={(e) => {
							referBack.reasons = e.value;
							referBack.reasons = referBack.reasons.map((e) => {
								if (!("notes" in e)) {
									e.notes = "";
									e.isRequired = true;
									// e.size = 0;
									e.message = `Message minimum length is ${referBack?.notes_length}. Current length is ${0}.`;
								}
								return e;
							});
							const cloned = JSON.parse(JSON.stringify(referBack));
							setReferBack(cloned);
						}}
						options={lookUp?.referralReasons || []}
						optionLabel="name"
						placeholder="Select Reason"
						maxSelectedLabels={3}
						className="w-full mb-2"
					/>
					<br />
					{referBack.reasons?.map((reason, index) => (
						<div>
							<label className="my-3">
								{reason.name}
								<span style={{ color: "red" }}>*</span>
							</label>
							<InputTextarea
								value={referBack?.reasons[index]?.notes}
								className="w-full mb-2"
								onChange={(e) => {
									var note = referBack.reasons[index];
									var text = e.target.value;
									note.size = text.trim().length;
									if (text.trim().length < referBack.notes_length) {
										note.isRequired = true;
										note.message = `Message minimum length is ${referBack?.notes_length}. Current length is ${note.size}.`;
									} else {
										note.isRequired = false;
										note.message = "";
									}
									referBack.reasons[index].notes = e.target.value;
									setReferBack({ ...referBack });
								}}
							/>
							<div key={referBack.reasons[index]?.message} style={{ color: "red" }} className="mb-2">
								{referBack.reasons[index]?.message}
							</div>
						</div>
					))}
				</Dialog>

				<PrintOutAction showDialog={showReport} setShowDialog={setShowReport} applicationID={applicationID} />
				<div className="grid">
					<div className="col-12 lg:col-12">
						{/* <GenericViewApplication setLoading={setLoading} loading={loading} applicationID={applicationID} myVoter={voter} /> */}

						<GenericViewApplication
							onHide={onHide}
							visible={visible}
							setLoading={setLoading}
							loading={loading}
							applicationID={applicationID}
							myVoter={voter}
							idNumber={idNumber}
						/>

						{/* {application && <ApplicationView />} */}
						{/* {application && application.applicationTypeID == 1 && <RegistrationView />}
						{application && application.applicationTypeID == 2 && <TransferView />}
						{application && application.applicationTypeID == 3 && <AmendmentView />}
						{application && <BinaryDataView />} */}
					</div>
				</div>
			</Dialog>
			<Dialog
				header={`${popUpInfo?.transact} Removal Application`}
				visible={showTransaction}
				style={{ width: "40vw" }}
				footer={
					<div>
						<Button icon="pi pi-check" loading={loading} label="Submit" onClick={submitApplication} className="p-button-primary" />
						<Button
							icon="pi pi-times-circle"
							label="Cancel"
							onClick={() => {
								setShowTransaction(false);
								setPopUpInfo({});
							}}
							className="p-button-danger"
						/>
					</div>
				}
				onHide={() => {
					setShowTransaction(false);
					setPopUpInfo({});
				}}
			>
				<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">
						Finding Date<span style={{ color: "red" }}>*</span>
					</label>
					<Calendar
						showIcon
						id="reason"
						rows={3}
						value={popUpInfo.findingDate}
						dateFormat="dd/mm/yy"
						placeholder="DD/MM/YYYY"
						onChange={(e) => setPopUpInfo({ ...popUpInfo, findingDate: e.value })}
					/>
				</div>

				<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">
						Finding Reason<span style={{ color: "red" }}>*</span>
					</label>
					<Dropdown
						id="reason"
						optionValue="id"
						optionLabel="name"
						options={lookUp?.removalFindings}
						rows={3}
						value={popUpInfo.removalFindingID}
						onChange={(e) => setPopUpInfo({ ...popUpInfo, removalFindingID: e.value })}
					/>
				</div>

				<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">
						Notes <span style={{ color: "red" }}>*</span>
					</label>
					<InputTextarea
						id="reason"
						rows={3}
						value={popUpInfo.note}
						onChange={(e) => setPopUpInfo({ ...popUpInfo, note: e.target.value })}
					/>
				</div>

				{/* 
				<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">Removal Reason</label>
					<Dropdown onChange={e => {
						popUpInfo.removal_reason = e.value;
						setPopUpInfo({ ...popUpInfo })
					}} value={popUpInfo.removal_reason} options={lookUp?.removalBinaryTypes} optionLabel="name" optionValue="id" />
				</div> */}
				<label htmlFor="notes">
					Supporting Document<span style={{ color: "red" }}>*</span>
				</label>
				<div className="flex ">
					<div></div>
				</div>

				<DataTable
					value={filesUpload}
					header={
						<>
							<FileUpload
								onSelect={async (e) => {
									const file = e.files.at(0);
									const fileExtension = file?.name?.split(".")?.pop() || "";
									filesUpload.push({
										binaryTypeID: 13,
										fileExt: fileExtension,
										binaryData: await fileToBase64_v2(file),
										description: file?.name
									});
									setFilesUpload([...filesUpload]);
									fileRef.current.clear();
								}}
								ref={fileRef}
								mode="basic"
								name="demo[]"
								accept="image/*"
								maxFileSize={1000000}
							/>
						</>
					}
				>
					<Column field="description" header="File Name"></Column>
					<Column
						field="#"
						header="Preview"
						body={(e, row) => <>{e.binaryData.includes("image") && <Image src={e.binaryData} preview height={50} width={50} />}</>}
					></Column>
					<Column
						field="remove"
						header="Remove"
						body={(_, row) => {
							return (
								<Button
									tooltip="delete file"
									tooltipOptions={{ position: "bottom" }}
									type="button"
									icon="pi pi-trash"
									onClick={(e) => {
										deleteConform(e, row.rowIndex);
									}}
									className="select-product-button p-button-danger p-mr-2 p-button-rounded"
								/>
							);
						}}
					></Column>
				</DataTable>

				{errorMessage && <Message severity="error" text={errorMessage} style={{ marginTop: "0.5em" }} />}
			</Dialog>

			<CorrectionView
				showCorrectionDetails={showCorrectionDetails}
				setshowCorrectionDetails={setshowCorrectionDetails}
				correctionDetails={correctionDetails}
				parentApplication={ApplicationInfo}
				voterData={voter}
				binaryData={binaryData}
			/>

			{ApplicationInfo?.parentApplicationID}
			<Dialog
				header={`Objection Application`}
				visible={objectionForm.show}
				style={{ width: "40vw" }}
				footer={
					<div>
						<Button
							icon="pi pi-check"
							loading={loading}
							label={"Submit"}
							onClick={() => {
								objectionApplication();
							}}
							className="p-button-primary"
						/>
						<Button
							icon="pi pi-times-circle"
							label="Cancel"
							onClick={() => {
								setObjectionForm({ Recommend: false, Withdraw: false, show: false });
								setPopUpInfo({});
							}}
							className="p-button-danger"
						/>
					</div>
				}
				onHide={() => {
					setObjectionForm({ Recommend: false, Withdraw: false, show: false });
					setPopUpInfo({});
				}}
			>
				{objectionForm.Recommend && (
					<div className="flex flex-column gap-2 mb-4">
						<label htmlFor="reason">
							Action Taken <span style={{ color: "red" }}>*</span>
						</label>
						<InputTextarea
							id="actionTaken"
							rows={3}
							value={popUpInfo.actionTaken}
							onChange={(e) => setPopUpInfo({ ...popUpInfo, actionTaken: e.target.value })}
						/>
					</div>
				)}

				<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">
						{objectionForm.Recommend ? "Suggested Action" : "Notes"} <span style={{ color: "red" }}>*</span>
					</label>
					<InputTextarea
						id="reason"
						rows={3}
						value={popUpInfo.note}
						onChange={(e) => setPopUpInfo({ ...popUpInfo, note: e.target.value })}
					/>
				</div>

				<label htmlFor="notes">
					Supporting Document<span style={{ color: "red" }}>*</span>
				</label>
				<div className="flex ">
					<div></div>
				</div>

				<DataTable
					value={filesUpload}
					header={
						<>
							<FileUpload
								onSelect={async (e) => {
									const file = e.files.at(0);
									const fileExtension = file?.name?.split(".")?.pop() || "";
									filesUpload.push({
										binaryTypeID: 13,
										fileExt: fileExtension,
										binaryData: await fileToBase64_v2(file),
										description: file?.name
									});
									setFilesUpload([...filesUpload]);
									fileRef.current.clear();
								}}
								ref={fileRef}
								mode="basic"
								name="demo[]"
								maxFileSize={1000000}
							/>
						</>
					}
				>
					<Column field="description" header="File Name"></Column>
					<Column
						field="#"
						header="Preview"
						body={(e, row) => <>{e.binaryData.includes("image") && <Image src={e.binaryData} preview height={50} width={50} />}</>}
					></Column>
					<Column
						field="remove"
						header="Remove"
						body={(_, row) => {
							return (
								<Button
									tooltip="delete file"
									tooltipOptions={{ position: "bottom" }}
									type="button"
									icon="pi pi-trash"
									onClick={(e) => {
										deleteConform(e, row.rowIndex);
									}}
									className="select-product-button p-button-danger p-mr-2 p-button-rounded"
								/>
							);
						}}
					></Column>
				</DataTable>

				{errorMessage && <Message severity="error" text={errorMessage} style={{ marginTop: "0.5em" }} />}
			</Dialog>
		</>
	);
}
